/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import { isIbanValid } from '@/services/api/payment/transactions';

// actions
const actions = {
  /**
   * Check iban format
   */
  async verifyIban({ rootGetters, dispatch }, actionModule) {
    try {
      const iban = rootGetters[`${actionModule}/iban`];
      const res = await isIbanValid(iban);
      dispatch(`${actionModule}/setValueWithPath`, { path: 'isIbanValid', value: res.data.valid }, { root: true });
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: actionModule }, { root: true });
    }
  },
};

export default {
  namespaced: true,
  actions,
};
